import {
  UPDATE_JOURNAL_ENTRIES_LIST,
  TOGGLE_JOURNAL_ENTRIES_LOADING,
  JOURNAL_ENTRIES_ERROR,
  JOURNAL_ENTRIES_UPDATE_TOTAL
} from '../actions/journalEntriesActions'

const initState = {
  name: 'Journal Entries',
  entries: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0
  }
}

const journalEntriesReducer = (state = initState, action) => {
  // Immutable nested update: return a NEW `entries` object so useSelector detects the change
  // (mutating in place kept the same reference → the loader never cleared).
  switch (action.type) {
    case UPDATE_JOURNAL_ENTRIES_LIST:
      return { ...state, entries: { ...state.entries, list: action.payload.value } }
    case JOURNAL_ENTRIES_UPDATE_TOTAL:
      return { ...state, entries: { ...state.entries, totalRecords: action.payload.value } }
    case TOGGLE_JOURNAL_ENTRIES_LOADING:
      return { ...state, entries: { ...state.entries, loading: action.payload.value } }
    case JOURNAL_ENTRIES_ERROR:
      return { ...state, entries: { ...state.entries, error: action.payload.value } }
    default:
      return state
  }
}

export default journalEntriesReducer
